import { Animation, ImageSource, Sound, SpriteSheet, Util, vec } from 'excalibur';
import sharkSide from './images/side_shark_sheet.png';
import sharkTop from './images/top_shark_sheet.png';
import map from './images/map.png';

import heartSharkSide from './images/side_queen_shark_sheet.png';
import heartSharkTop from './images/top_queen_shark_sheet.png';

import diamondSharkSide from './images/side_jack_of_diamonds_sheet.png';
import diamondSharkTop from './images/top_jack_of_diamonds_sheet.png';

import die1 from './images/die/Alea_1.png';
import die2 from './images/die/Alea_2.png';
import die3 from './images/die/Alea_3.png';
import die4 from './images/die/Alea_4.png';
import die5 from './images/die/Alea_5.png';
import die6 from './images/die/Alea_6.png';

import seal from './images/seal_sheet.png'
import moneySeal from './images/hat_seal_sheet.png'

import gameIntro from './images/game_intro.wav';
import gameLoop from './images/game_loop.wav';

import menuIntro from './images/menu_intro.wav';
import menuLoop from './images/menu_loop.wav';

import sealPlaced from './images/seal_placed.wav';
import buttonClick from './images/button_click.wav';
import diceRoll from './images/dice_roll.wav';
import diceShake from './images/dice_shake.wav';

import bottomBar from './images/bottom_board.png'

import title from './images/title.png'
import lose from './images/lose.png'

import youLose from './images/you_lose.wav'

import bullet from './images/dumb_dumb_idiot_bullet.png';
import button from './images/button.png';

import { range } from './util';

/**
 * Default global resource dictionary. This gets loaded immediately
 * and holds available assets for the game.
 */
export const Resources = {
    sharkSide: new ImageSource(sharkSide),
    sharkTop: new ImageSource(sharkTop),
    map: new ImageSource(map),
    die1: new ImageSource(die1),
    die2: new ImageSource(die2),
    die3: new ImageSource(die3),
    die4: new ImageSource(die4),
    die5: new ImageSource(die5),
    die6: new ImageSource(die6),
    seal: new ImageSource(seal),
    moneySeal: new ImageSource(moneySeal),
    gameIntro: new Sound(gameIntro),
    gameLoop: new Sound(gameLoop),
    menuIntro: new Sound(menuIntro),
    menuLoop: new Sound(menuLoop),
    bottomBar: new ImageSource(bottomBar),
    heartSharkSide: new ImageSource(heartSharkSide),
    heartSharkTop: new ImageSource(heartSharkTop),
    diamondSharkSide: new ImageSource(diamondSharkSide),
    diamondSharkTop: new ImageSource(diamondSharkTop),
    title: new ImageSource(title),
    lose: new ImageSource(lose),
    youLose: new Sound(youLose),
    bullet: new ImageSource(bullet),
    button: new ImageSource(button),
    sealPlaced: new Sound(sealPlaced),
    buttonClick: new Sound(buttonClick),
    diceRoll: new Sound(diceRoll),
    diceShake: new Sound(diceShake),
}

export let derived: ReturnType<typeof loadDerived>;

export function onLoadComplete() {
    derived = loadDerived();
}

function loadDerived() {
    const sealSpritesheet = SpriteSheet.fromImageSource({
        image: Resources.seal,
        grid: {
            rows: 1,
            columns: 6,
            spriteWidth: 586.8333333,
            spriteHeight: 643,

        },
    });

    for (const sprite of sealSpritesheet.sprites) {
        sprite.destSize = {
            width: 140,
            height: 140,
        };
    }

    const sealIcon = sealSpritesheet.getSprite(0, 0);
    
    const moneySealSpriteSheet = SpriteSheet.fromImageSource({
        image: Resources.moneySeal,
        grid: {
            rows: 1,
            columns: 6,
            spriteWidth: 662,
            spriteHeight: 661,

        },
    });

    for (const sprite of moneySealSpriteSheet.sprites) {
        sprite.destSize = {
            width: 140,
            height: 140,
        };
    }

    const moneySealIcon = moneySealSpriteSheet.getSprite(0, 0);

    return {
        sealSpritesheet,
        sealIcon,
        moneySealSpriteSheet,
        moneySealIcon
    }
}